import { FilterType } from 'library/Types';
import { MasterConfig, ConsignmentBucketKeys } from '../../types/master-data-types';
import moment from 'moment';

export const getFilters = (
    bucket: ConsignmentBucketKeys,
    config: MasterConfig,
    dashboardFilterIds?: string[],
) => {
    if (!bucket || !config || !config.filter_list_by_bucket || !config.filter_metadata) {
        return [];
    }
    const mainDashboardFilters:
    string[] = ['statusList', 'customerReferenceNumberList', 'referenceNumberList', 'bookingServiceTypeIdList'];
    let dashboardFilters = config?.filter_list_by_bucket[bucket];
    dashboardFilters = dashboardFilters.filter((filter) => (filter.show_on_main_dashboard));
    dashboardFilters = dashboardFilters.filter((filter) => !mainDashboardFilters.includes(filter.id));
    const filterIdList = dashboardFilterIds || dashboardFilters.map((filter) => (filter.id));
    filterIdList.push('cncFlag');

    const filtersToShow = config.filter_metadata.filter((filter) => filterIdList.includes(filter.id));
    filtersToShow.push({
        id: 'cncFlag',
        mode: undefined,
        label: 'C&C Flag',
        placeholder: 'C&C Flag',
        type: FilterType.select,
        options: [{
            label: 'ALL',
            value: 'all',
        }, {
            label: 'True',
            value: 'true',
        }, {
            label: 'False',
            value: 'false',
        }],
    });
    return filtersToShow;
};

// Status color mapping
export const STATUS_COLOR_MAP: Record<string, { color: string; background: string }> = {
    // Blue
    created: { color: '#1677ff', background: '#e6f4ff' },
    softdata_upload: { color: '#1677ff', background: '#e6f4ff' },
    pickup_scheduled: { color: '#1677ff', background: '#e6f4ff' },
    pickup_awaited: { color: '#1677ff', background: '#e6f4ff' },
    out_for_pickup: { color: '#1677ff', background: '#e6f4ff' },
    rto: { color: '#1677ff', background: '#e6f4ff' },

    // Yellow
    pickup_completed: { color: '#bfa100', background: '#fffbe6' },
    reachedathub: { color: '#bfa100', background: '#fffbe6' },
    inscan_at_hub: { color: '#bfa100', background: '#fffbe6' },
    intransittohub: { color: '#bfa100', background: '#fffbe6' },
    handover_courier_partner: { color: '#bfa100', background: '#fffbe6' },
    in_transit: { color: '#bfa100', background: '#fffbe6' },
    outfordelivery: { color: '#bfa100', background: '#fffbe6' },
    rto_outfordelivery: { color: '#bfa100', background: '#fffbe6' },

    // Green
    delivered: { color: '#389e0d', background: '#f6ffed' },
    rto_delivered: { color: '#389e0d', background: '#f6ffed' },

    // Red
    not_picked_up: { color: '#cf1322', background: '#fff1f0' },
    attempted: { color: '#cf1322', background: '#fff1f0' },
    cancelled: { color: '#cf1322', background: '#fff1f0' },
    rto_attempted: { color: '#cf1322', background: '#fff1f0' },
};

export const formatDateTime = (epochTime : number, type: string, format?: string) => {
    if (!epochTime) return 'N/A';
    let dateTime;
    if (epochTime.toString().length < 13) {
        dateTime = moment(new Date(Number(epochTime) * 1000));
    } else {
        dateTime = moment(new Date(Number(epochTime)));
    }
    if (!dateTime.isValid()) return 'N/A';
    if (type === 'date') {
        return dateTime.format('DD MMM YYYY');
    }
    if (type === 'time') {
        return dateTime.format('HH:mm:ss');
    }
    return dateTime.format(format || 'DD MMM YYYY, hh:mm:ss A');
};
